import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DOCS_GETTING_STARTED_URL } from '@app/config';
import { SectionHeaderComponent } from '@app/widgets';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-live-updates-how-it-works-section',
  imports: [SectionHeaderComponent, TuiButton],
  templateUrl: './live-updates-how-it-works-section.component.html',
  styleUrl: './live-updates-how-it-works-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveUpdatesHowItWorksSectionComponent {
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
  protected readonly docsUrl = DOCS_GETTING_STARTED_URL;
}
